const viTranslations = {
  language_label: "Ngôn ngữ",
  vietnamese: "Tiếng Việt",
  chinese: "Tiếng Trung",
  english: "Tiếng Anh",
  open_categories: "Mở danh mục",
  search_placeholder: "Tìm sản phẩm, mã sản phẩm, hãng...",
  customer_utilities: "Tiện ích khách hàng",
  account_fallback: "Tài khoản",
  logout_success: "Đăng xuất thành công",
  logout_failed: "Đăng xuất thất bại",
  generic_error_retry: "Đã xảy ra lỗi. Vui lòng thử lại sau.",
  mobile_navigation: "Điều hướng trên điện thoại",
  support: "Hỗ trợ",
  back_to_top: "Lên đầu trang",
  shipping_policy: "Vận chuyển & giao nhận",
  privacy_policy: "Chính sách bảo mật",
  shopping_guide: "Hướng dẫn mua hàng",
  warranty_request: "Yêu cầu bảo hành",
  send_support_request: "Gửi yêu cầu hỗ trợ",
  technical_support_247: "Hỗ trợ kỹ thuật 24/7",
  hotline_label: "Hotline",
  breadcrumb: "Đường dẫn điều hướng",
  brand_label: "Hãng:",
  token_expired_login: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  login_required_action: "Bạn cần đăng nhập để thực hiện hành động này.",
  add_cart_success: "Đã thêm sản phẩm vào giỏ hàng.",
  cart_status_updated: "Đã cập nhật trạng thái sản phẩm.",
  cart_cleared: "Đã xóa toàn bộ giỏ hàng.",
  view_all: "Xem tất cả",
  view_all_categories: "Xem tất cả danh mục",
  industrial_solutions: "TTSMART INDUSTRIAL SOLUTIONS",
  equipment_solutions: "Giải pháp thiết bị",
  for_concrete_mixing_stations: "cho trạm trộn bê tông",
  genuine_quality: "Chính hãng - Chất lượng",
  expert_technical_consulting: "Tư vấn kỹ thuật chuyên sâu",
  official_warranty: "Bảo hành chính hãng",
  explore_now: "Khám phá ngay",
  download_catalogue: "Tải catalogue",
  featured_categories: "Danh mục nổi bật",
  loading_products: "Đang tải sản phẩm...",
  add_to_favorites: "Thêm vào yêu thích",
  featured_brands: "Thương hiệu nổi bật",
  view_more: "Xem thêm",
  product_type_label: "Loại sản phẩm:",
  cluster_label: "Cụm:",
  equipment_label: "Thiết bị:",
  real_image_100: "Ảnh thật 100%",
  return_by_policy: "Đổi trả theo chính sách",
  reviews_suffix: "đánh giá",
  sold_label: "Đã bán",
  vat_excluded: "Giá chưa bao gồm VAT",
  buy_now: "Mua ngay",
  call_now: "Gọi ngay 0813.15.83.83",
  chat_zalo: "Chat Zalo",
  hotline_number: "Đường dây nóng 0813.15.83.83",
  ttsmart_commitment: "Cam kết từ TTSmart",
  nationwide_delivery: "Giao hàng toàn quốc",
  related_products: "Sản phẩm liên quan",
  product_info_updating: "Thông tin sản phẩm đang được cập nhật.",
  manual_label: "Hướng dẫn sử dụng",
  datasheet_label: "Bảng thông số",
  catalog_label: "Catalogue",
  chat: "Chat",
  call: "Gọi",
  contact_for_quote: "Liên hệ báo giá",
  customer_information: "Thông tin dành cho khách hàng",
  policy_page_description: "Tìm hiểu quy định mua hàng, giao nhận, bảo hành và bảo mật thông tin tại TTSmart.",
  loading_policy_content: "Đang tải nội dung chính sách...",
  policy_categories: "Danh mục chính sách",
  need_help: "Cần hỗ trợ?",
  support_team_ready: "Đội ngũ TTSmart sẵn sàng giải đáp.",
  last_updated: "Cập nhật lần cuối:",
  policy_contact_prompt: "Nếu còn câu hỏi về chính sách này, vui lòng liên hệ để được hỗ trợ.",
  contact_now: "Liên hệ ngay",
  policy_load_error: "Không thể tải nội dung chính sách. Vui lòng thử lại sau.",
  loading_station_data: "Đang tải dữ liệu trạm...",
  login_required_title: "Yêu cầu đăng nhập",
  login_required_station_desc: "Bạn cần đăng nhập bằng tài khoản khách hàng để xem danh sách các trạm của mình.",
  assigned_stations_desc: "Danh sách các trạm đã được gán cho tài khoản của bạn để quản lý và theo dõi.",
  total_stations: "Tổng số trạm",
  active_stations: "Trạm đang hoạt động",
  active_station: "Trạm hoạt động",
  maintenance_station: "Trạm bảo trì",
  stopped_station: "Trạm dừng hoạt động",
  assigned_station_list: "Danh sách trạm được gán",
  search_stations: "Tìm kiếm trạm...",
  list_view: "Danh sách",
  grid_view: "Lưới",
  no_matching_stations: "Không tìm thấy trạm nào phù hợp.",
  actions: "Thao tác",
  active: "Hoạt động",
  code_label: "Mã:",
  showing: "Hiển thị",
  of: "trong số",
  stations_unit: "trạm",
  devices_unit: "thiết bị",
  per_page: "/ trang",
  item_label: "Viên",
  button_count: "Số nút",
  rows_per_page_10: "10 hàng mỗi trang",
  view_details: "Xem chi tiết",
  microphone_secure_required: "Trình duyệt yêu cầu HTTPS hoặc localhost để sử dụng micro.",
  speak_longer: "Vui lòng nói lâu hơn một chút trước khi bấm dừng.",
  listening_instructions: "Đang lắng nghe... Bấm lại nút micro khi nói xong.",
  microphone_permission_error: "Không thể mở micro. Vui lòng cấp quyền micro cho trang web.",
  processing_voice: "Đang xử lý giọng nói...",
  search_text_required: "Vui lòng nhập câu tìm kiếm.",
  processing_search: "Đang xử lý câu tìm kiếm...",
  voice_search_placeholder: "Nhập câu tìm kiếm, ví dụ: tìm van điện khí TTSM1",
  switch_to_text_input: "Chuyển sang nhập bằng bàn phím",
  switch_to_voice_input: "Chuyển sang tìm kiếm bằng giọng nói",
  auto_login_success: "Đăng nhập tự động thành công!",
  auto_logging_in: "Đang đăng nhập tự động...",
  image_heading: "Hình ảnh",
  display_range: "Hiển thị",
  page_size_10: "10 / trang",
  page_size_20: "20 / trang",
  page_size_50: "50 / trang",
  policy_purchase_title: "Chính sách mua hàng",
  policy_warranty_title: "Bảo hành & đổi trả",
  policy_shipping_title: "Vận chuyển & giao nhận",
  policy_privacy_title: "Chính sách bảo mật",
  policy_purchase_short: "Mua hàng",
  policy_warranty_short: "Bảo hành & đổi trả",
  policy_shipping_short: "Vận chuyển",
  policy_privacy_short: "Bảo mật",
  unknown: "Chưa rõ",
  stock_quantity: "Số lượng tồn",
  add_product_to_cart: "Thêm sản phẩm vào giỏ hàng",
  search_result_prefix: "Tìm kiếm",
  audio_parse_failed: "Không phân tích được âm thanh.",
  voice_process_error: "Gặp lỗi khi xử lý giọng nói.",
  text_parse_failed: "Không phân tích được câu tìm kiếm.",
  search_process_error: "Gặp lỗi khi xử lý câu tìm kiếm.",
  close_text_input: "Đóng ô nhập chữ",
  keyboard_search: "Nhập câu tìm kiếm bằng bàn phím",
  stop_and_search: "Bấm lại để dừng và tìm kiếm",
  start_voice_search: "Bấm để bắt đầu tìm kiếm bằng giọng nói",
  auto_login_missing_code: "Không có mã đăng nhập.",
  auto_login_failed: "Đăng nhập tự động thất bại.",
  auto_login_error: "Lỗi khi đăng nhập tự động.",
  product_display_range: "Hiển thị {first}–{last} trong {total} sản phẩm",
  product_code_label: "Mã sản phẩm",
  manufacturer_label: "Hãng sản xuất",
  product_type_summary_label: "Loại sản phẩm",
  color_label: "Màu sắc",
  shape_label: "Hình dạng",
  frame_label: "Khung",
  in_stock: "Còn hàng",
  remaining_products: "Còn {count} sản phẩm",
  pdf_document: "Tài liệu PDF",
  technical_document: "Tài liệu kỹ thuật",
  remove_from_cart: "Xóa khỏi giỏ hàng",
  product_categories: "Danh mục sản phẩm",
  best_selling_products: "Sản phẩm bán chạy",
  genuine_products: "Hàng chính hãng",
  genuine_commitment: "Cam kết 100% chính hãng",
  trusted_warranty: "Bảo hành uy tín",
  fast_on_time_delivery: "Giao nhanh - Đúng hẹn",
  support_247: "Hỗ trợ 24/7",
  free_technical_consulting: "Tư vấn kỹ thuật miễn phí",
  category: "Danh mục",
  unknown_error: "Đã xảy ra lỗi không xác định.",
  percent_of_total_stations: "{percent}% tổng số trạm",
  station_image: "Ảnh trạm",
  station_name: "Tên trạm",
  station_code: "Mã trạm",
  product_count: "Số sản phẩm",
  location: "Vị trí",
  station_display_range: "Hiển thị {first}–{last} trong số {total} trạm",
  device_display_range: "Hiển thị {first}–{last} trong số {total} thiết bị",
  station_not_found: "Không tìm thấy trạm.",
  updating_status: "Đang cập nhật",
  introduction_empty: "Chưa có nội dung giới thiệu.",
  loading_introduction: "Đang tải nội dung giới thiệu...",
  introduction_load_error: "Không thể tải nội dung giới thiệu. Vui lòng thử lại sau.",
  error_occurred: "Đã xảy ra lỗi",
  password_strength_weak: "Yếu",
  password_strength_medium: "Trung bình",
  password_strength_good: "Tốt",
  password_strength_strong: "Mạnh",
  fill_all_fields: "Vui lòng nhập đầy đủ thông tin",
  password_minimum_length: "Mật khẩu phải có ít nhất 6 ký tự",
  change_password_failed: "Đổi mật khẩu thất bại",
  change_password_success: "Đổi mật khẩu thành công",
  server_error: "Lỗi máy chủ, vui lòng thử lại sau",
  change_password_description: "Vui lòng tạo mật khẩu mới để bảo vệ tài khoản của bạn.",
  current_password_placeholder: "Nhập mật khẩu hiện tại",
  toggle_password_visibility: "Hiện hoặc ẩn mật khẩu",
  new_password_placeholder: "Nhập mật khẩu mới",
  password_strength: "Độ mạnh mật khẩu",
  password_rule_note: "Mật khẩu phải có ít nhất 6 ký tự; nên kết hợp chữ hoa, chữ thường, số và ký tự đặc biệt.",
  confirm_password_placeholder: "Nhập lại mật khẩu mới",
  encrypted_security_note: "Thông tin của bạn được mã hóa và bảo mật.",
  copied: "Đã sao chép mã đơn",
  copy_failed: "Không thể sao chép mã đơn",
  other_products: "sản phẩm khác",
  orders_description: "Theo dõi trạng thái xử lý, giao hàng và thanh toán của các đơn đã đặt.",
  order_status: "Trạng thái đơn hàng",
  loading_orders: "Đang tải đơn hàng...",
  unable_to_load_orders: "Không thể tải đơn hàng",
  try_again: "Thử lại",
  empty_orders_hint: "Không có đơn hàng phù hợp với trạng thái bạn đang chọn.",
  continue_shopping: "Tiếp tục mua sắm",
  copy_order_code: "Sao chép mã đơn",
  construction: "Công trình",
  full_name_required: "Vui lòng nhập họ và tên",
  account_info_description: "Quản lý thông tin liên hệ và các địa chỉ nhận hàng của bạn.",
  personal_info_hint: "Thông tin dùng để liên hệ và xác nhận đơn hàng",
  edit: "Chỉnh sửa",
  account_security: "Bảo mật tài khoản",
  change_password_regularly: "Đổi mật khẩu định kỳ để bảo vệ tài khoản của bạn.",
  address_book_hint: "Lưu địa chỉ để đặt hàng nhanh hơn",
  no_saved_address_title: "Chưa có địa chỉ nhận hàng nào",
  add_new_address: "Thêm địa chỉ mới",
  set_default: "Đặt làm mặc định",
  default: "Mặc định",
  delete: "Xóa",
  my_addresses: "Địa chỉ của tôi",
  my_account: "Tài khoản của tôi",
  customer_support_247: "Hỗ trợ khách hàng 24/7",
  contact_price: "Liên hệ",
  product_image_alt: "Ảnh sản phẩm",
  product_no_longer_exists: "Sản phẩm không còn tồn tại",
  register_failed: "Không thể đăng ký tài khoản. Email hoặc số điện thoại có thể đã được sử dụng.",
  otp_send_failed: "Không thể gửi mã OTP. Vui lòng kiểm tra thông tin và thử lại.",
  reset_password_failed: "Không thể đặt lại mật khẩu. Mã OTP có thể không đúng hoặc đã hết hạn.",
  order_creation_failed: "Không thể tạo đơn hàng. Vui lòng kiểm tra lại giỏ hàng và thử lại.",
};

export default viTranslations;
